export class StringUtil {
    public static getSeparateArrayOfListString(listString: string): Array<string> {
        if (!listString) { return null; }
        if (listString === '') { return null; }
        const splitString = listString.split(',');
        const separateList = new Array<string>();
        for (const oneSplit of splitString) {
          separateList.push(oneSplit);
        }
        return separateList;
    }

    public static getSeparateArrayOfRangeString(listString: string): Array<string> {
      if (!listString) { return null; }
      if (listString === '') { return null; }
      const splitString = listString.split('-');
      const separateList = new Array<string>();
      for (const oneSplit of splitString) {
        separateList.push(oneSplit);
      }
      return separateList;
  }

    public static getSeparateArrayOfStringWords(listString: string): Array<string> {
      if (!listString) { return null; }
      if (listString === '') { return null; }
      const splitString = listString.split(' ');
      const separateList = new Array<string>();
      for (const oneSplit of splitString) {
        separateList.push(oneSplit);
      }
      return separateList;
  }

    public static getStringCamelCase(data: string) : string{
      let dataAux = '';
      this.getSeparateArrayOfStringWords(data).forEach(d => {
        dataAux = dataAux + (d.charAt(0).toUpperCase() + d.slice(1).toLocaleLowerCase()) + ' ';
      });
      return dataAux.substring(0, dataAux.length -1);
    }
}
